export default __webpack_public_path__ + "static/media/IMG-20240729-WA0011.f916b0e8.jpg";